import {
  actionCreator,
  checkHttpStatus,
  FORGOT_PASSWORD_API,
  handleLoginRedirect,
  handleLogoutRedirect,
  jsonApiHeader,
  jsonApiHeaderBusinessName,
  LOGIN_API,
  loginActionTypes,
  REFRESH_TOKEN,
  RESET_PASSWORD_API, 
  UPDATE_LOGIN_PASSWORD_API} from './../constants/ApiConstants';
import { showSuccessMessage } from '../../../patients/constants/ApiConstants';
import history from '../../../../history';

export function superAdminLoginAction(authData) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_login.REQUEST));
    fetch(`${LOGIN_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: jsonApiHeaderBusinessName(null, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response...........',response)
        if ((response.statusCode >= 400 && response.statusCode < 500) && response.message) {
          let errorMessage = response.message;
          dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, currentLocationId: null, loginUserInfo: null }));
        } else if (response.statusCode === 205) {
          let errorMessage = response.message;
          dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { response: response, errorMessage: errorMessage, currentLocationId: null, access_token: null, loginUserInfo: null, isOnlyForAgency: false }));
          
        } else {
          if (response.access_token) {
            if (response.data.roleName.toUpperCase() === 'SUPERADMIN' || response.data.roleName.toUpperCase() === 'SUPERUSER') {
              localStorage.setItem('superuser', true);
              dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, access_token: response.access_token, loginUserInfo: response.data, isOnlyForAgency : false }));
              handleLoginRedirect(response.access_token, '', '/webadmin/dashboard');
            }
          }
        }
      }).catch(function(error) {
        console.log('error: ', error);
        let errorMessage = 'Invalid username or password';
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, currentLocationId: null, access_token: null, loginUserInfo: null }));
      });
  };
}

export function logoutAction() {
  return (dispatch) => {
    localStorage.removeItem('superuser');
    dispatch(actionCreator(loginActionTypes.logout_user.SUCCESS));
    handleLogoutRedirect('/webadmin/login');
  };
}

export function refreshAuthTokenSuperAdmin(old_token) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.refresh_token.REQUEST));
    fetch(`${REFRESH_TOKEN}`, {
      method: 'get',
      headers: jsonApiHeader(old_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('mks----------', response)
        dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, access_token: response.access_token, loginUserInfo: response.data, isOnlyForAgency : false }));
        handleLoginRedirect(response.access_token, '', '/webadmin/dashboard');
      }).catch(function(error) {
        console.log(error);
        // console.log(''Oops, something went wrong, please try later'--', 'Oops, something went wrong, please try later')
        let errorMessage = 'Oops, something went wrong, please try later';
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
        handleLogoutRedirect('/webadmin/login');
      });
  };
}

export function forgotPasswordAction(authData) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_forgotPassword.REQUEST));
    fetch(`${FORGOT_PASSWORD_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        let successMessage = 'Forgot password request processed successfully. Please check your registered email for further instructions.';
        showSuccessMessage(successMessage);
        // Alert.success(successMessage, {
        //   position: 'top',
        //   effect: 'slide',
        // });
        dispatch(actionCreator(loginActionTypes.post_forgotPassword.SUCCESS));
        handleLogoutRedirect('/webadmin/login');
      }).catch(function(error) {
       // console.log('error: ', error);
        let errorMessage = 'Forgot password request processed successfully. Please check your registered email for further instructions.';
        dispatch(actionCreator(loginActionTypes.post_forgotPassword.SUCCESS, { errorMessage: errorMessage }));
      });
  };
}

export function ResetPasswordAction(authData) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_resetPassword.REQUEST));
    fetch(`${RESET_PASSWORD_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        showSuccessMessage('Password reset successfully! Please login with new credentials.');
        // Alert.success('Password reset successfully! Please login with new credentials.', {
        //   position: 'top',
        //   effect: 'slide',
        // });
        dispatch(actionCreator(loginActionTypes.post_resetPassword.SUCCESS));
        handleLogoutRedirect('/webadmin/login');
      }).catch(function(error) {
        //console.log('error: ', error);     
        //let errorMessage = 'Invalid user credentials';
        let errorMessage = 'Password reset successfully! Please login with new credentials.';        
        dispatch(actionCreator(loginActionTypes.post_resetPassword.SUCCESS, { errorMessage: errorMessage }));
        history.push('/webadmin/login');
      });
  };
}


export function updateLoginUserPasswordAction(postData, businessNameCheck) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.update_loginUserPassword.REQUEST));
    fetch(`${UPDATE_LOGIN_PASSWORD_API}`, {
      method: 'PATCH',
      body: JSON.stringify(postData),
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300) {
          let responseObj = { response: response, successMessage: response.message, errorMessage: null };
          dispatch(actionCreator(loginActionTypes.update_loginUserPassword.SUCCESS, responseObj));
        } else {
          let responseObj = { response: response, successMessage: null, errorMessage: response.message };
          dispatch(actionCreator(loginActionTypes.update_loginUserPassword.SUCCESS, responseObj));
        }
      })
      .catch(function(error) {
        console.log(error);
        let errorMessage = 'Oops, something went wrong, please try later';
        dispatch(actionCreator(loginActionTypes.update_loginUserPassword.SUCCESS, { errorMessage: errorMessage }));
      });
  };
}

// export function verifyUserToken(token) {
//   return (dispatch) => {
//     fetch(`${VERIFY_TOKEN_API}`, {
//       method: 'post',
//       body: JSON.stringify(token),
//       headers: { 'Content-Type': 'application/json' },
//     })
//     .then(checkHttpStatus)
//     .then(function(response) {

//     })
//     .catch(function(error) {
//       console.log('error: ', error);
//       handleLogoutRedirect();
//     });
//   };
// }

// export function changeLocationAction(locationId, loginInfo) {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: locationId, access_token: getState().login.access_token, loginUserInfo: loginInfo, isOnlyForAgency : false }));
//   };
// }



// WEBPACK FOOTER //
// ./src/modules/Superadmin/logins/actions/LoginActions.js